import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconCut$1 = /*@__PURE__*/ proxyCustomElement(class WppIconCut extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-cut", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M14.8789 3.15883L11.78 7.92634L10.8873 6.54737L13.6212 2.34135C13.8469 1.99405 14.3115 1.89551 14.6588 2.12126C15.0061 2.347 15.1046 2.81153 14.8789 3.15883ZM12.4952 11.7512C12.8813 11.5894 13.3052 11.5001 13.75 11.5001C15.5449 11.5001 17 12.9552 17 14.7501C17 16.545 15.5449 18.0001 13.75 18.0001C11.9551 18.0001 10.5 16.545 10.5 14.7501C10.5 13.9429 10.7943 13.2044 11.2814 12.6361L10 10.6647L8.71861 12.6361C9.20573 13.2044 9.5 13.9429 9.5 14.7501C9.5 16.545 8.04493 18.0001 6.25 18.0001C4.45507 18.0001 3 16.545 3 14.7501C3 12.9552 4.45507 11.5001 6.25 11.5001C6.69479 11.5001 7.11872 11.5894 7.5048 11.7512L9.1055 9.28857L5.12117 3.15883C4.89543 2.81154 4.99397 2.347 5.34126 2.12126C5.68856 1.89552 6.15309 1.99406 6.37883 2.34135L12.4952 11.7512ZM12.6913 13.3566C12.2712 13.6762 12 14.1815 12 14.7501C12 15.7166 12.7835 16.5001 13.75 16.5001C14.7165 16.5001 15.5 15.7166 15.5 14.7501C15.5 13.7836 14.7165 13.0001 13.75 13.0001C13.3606 13.0001 13.0009 13.1273 12.7101 13.3424C12.7039 13.3472 12.6976 13.3519 12.6913 13.3566ZM6.25 13.0001C5.2835 13.0001 4.5 13.7836 4.5 14.7501C4.5 15.7166 5.2835 16.5001 6.25 16.5001C7.2165 16.5001 8 15.7166 8 14.7501C8 14.1812 7.72853 13.6757 7.30807 13.3561C7.30215 13.3518 7.29631 13.3474 7.29055 13.3429C6.9997 13.1275 6.63973 13.0001 6.25 13.0001Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-cut-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-cut", "wpp-icon-cut-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-cut-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-cut-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconCut$1);
      }
      break;
  } });
}

const WppIconCut = WppIconCut$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconCut, defineCustomElement };
